import { render, staticRenderFns } from "./x-text-item.vue?vue&type=template&id=46ff1cae&scoped=true&"
import script from "./x-text-item.vue?vue&type=script&lang=js&"
export * from "./x-text-item.vue?vue&type=script&lang=js&"
import style0 from "./x-text-item.vue?vue&type=style&index=0&id=46ff1cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ff1cae",
  null
  
)

export default component.exports